import { render, staticRenderFns } from "./app-flex-energetica.vue?vue&type=template&id=55b455cc"
import script from "./app-flex-energetica.vue?vue&type=script&lang=js"
export * from "./app-flex-energetica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports